import React, { useState, useEffect } from 'react';
import DownloadButton from './DownloadButton';
import RefineButton from './RefineButton';

const REFINEMENT_API_URL = process.env.REACT_APP_REFINE_API_URL;

const TranscriptBox = ({ transcript }) => {
  const [copied, setCopied] = useState(false);
  const [editableText, setEditableText] = useState(transcript);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    setEditableText(transcript);
  }, [transcript]);

  const handleCopy = () => {
    navigator.clipboard.writeText(editableText);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="alert alert-success mt-3 shadow" style={styles.container}>
      <strong>
        <span role="img" aria-label="document">📝</span> Transcription:
      </strong>
      <div className="d-flex gap-2 mt-3 flex-wrap">
        <button
          onClick={handleCopy}
          className="btn btn-outline-secondary btn-sm"
          style={styles.copyBtn}
          aria-label="Copy transcript"
        >
          <span role="img" aria-label="copy">📋</span>
          {copied ? 'Copied!' : 'Copy'}
        </button>
        <RefineButton
          text={editableText}
          onRefined={setEditableText}
          apiUrl={REFINEMENT_API_URL}
        />
        <DownloadButton text={editableText} />
      </div>
      {/* Transcript at the bottom */}
      {!editing ? (
        <div
          style={styles.transcriptBox}
          onClick={() => setEditing(true)}
          title="Click to edit"
        >
          {editableText}
        </div>
      ) : (
        <textarea
          className="form-control mt-2"
          style={styles.textarea}
          value={editableText}
          onChange={e => setEditableText(e.target.value)}
          onBlur={() => setEditing(false)}
          autoFocus
        />
      )}
      {!editing && (
        <div className="text-muted mt-2" style={styles.tip}>
          <span role="img" aria-label="tip">💡</span> Click the transcript to edit.
        </div>
      )}
    </div>
  );
};

// Styles moved to the bottom for clarity
const styles = {
  container: {
    borderRadius: '1rem',
    wordBreak: 'break-word',
    overflowWrap: 'break-word'
  },
  copyBtn: {
    borderRadius: '1.5rem',
    fontWeight: 'bold',
    minWidth: 90
  },
  tip: {
    fontSize: '0.9rem'
  },
  transcriptBox: {
    whiteSpace: 'pre-line',
    fontSize: '1rem',
    marginTop: '1rem',
    minHeight: 100,
    cursor: 'pointer',
    background: '#f8fafc',
    borderRadius: '0.75rem',
    padding: '1rem',
    border: '1px solid #e0e7ef',
    boxShadow: '0 1px 2px rgba(59,130,246,0.04)'
  },
  textarea: {
    minHeight: 100,
    resize: 'vertical',
    fontSize: '1rem',
    background: '#f8fafc',
    borderRadius: '0.75rem',
    border: '1px solid #e0e7ef'
  }
};

export default TranscriptBox;